import { MenuDivider, MenuItem, SubMenu } from '@szhsin/react-menu'
import { Icon } from '../../../common/components/Icon'
import { MenuBarItem } from '../../../common/components/Menu/MenuBarItem'
import { MenuItemWithKeybind } from '../../keybindings/MenuItemWithKeybind'
import { useAppDispatch } from '../../store/hooks'
import { bookmarksSlice } from './bookmarksSlice'
import { exportBookmarks, importBookmarks } from './io'
import { BookmarkEntry, BookmarkFolder } from './model'
import { useBookmarkWalk, useGotoBookmark } from './navigation'
import recommendedBookmarksJson from './recommendedBookmarks.json'
import { useBookmarkState } from './storage'

const recommendedBookmarks = recommendedBookmarksJson as BookmarkFolder

export function BookmarksMenu() {
  const state = useBookmarkState()
  const dispatch = useAppDispatch()
  const gotoBookmark = useGotoBookmark()
  const { walk, stop, walking } = useBookmarkWalk()

  return (
    <MenuBarItem label={<Icon type='bookmarks' />}>
      <MenuItemWithKeybind keybind='addBookmark'>Add Bookmark...</MenuItemWithKeybind>
      <MenuItemWithKeybind keybind='editBookmarks'>Edit Bookmarks...</MenuItemWithKeybind>
      <MenuDivider />
      <MenuItem onClick={() => exportBookmarks(state.root)}>Export</MenuItem>
      <MenuItem onClick={() => void importBookmarks()}>Import...</MenuItem>
      <MenuDivider />
      <MenuItem onClick={() => dispatch(bookmarksSlice.actions.walkSettingsToggled({ open: true }))}>
        Walk Setting...
      </MenuItem>
      <MenuItem onClick={() => void walk(state.root)}>Walk All Bookmarks</MenuItem>
      <MenuItem disabled={!walking} onClick={stop}>Stop Walking</MenuItem>
      <MenuDivider />
      {state.root.children.map((entry, index) => (
        <BookmarkMenuEntry
          key={index}
          entry={entry}
          onGoto={bookmark => gotoBookmark(bookmark)}
          onWalk={folder => void walk(folder)}
        />
      ))}
      <MenuDivider />
      <BookmarkMenuEntry
        entry={recommendedBookmarks}
        onGoto={bookmark => gotoBookmark(bookmark)}
        onWalk={folder => void walk(folder)}
      />
    </MenuBarItem>
  )
}

function BookmarkMenuEntry({
  entry,
  onGoto,
  onWalk,
}: {
  entry: BookmarkEntry
  onGoto: (bookmark: Extract<BookmarkEntry, { isFolder: false }>) => void
  onWalk: (folder: BookmarkFolder) => void
}) {
  if (entry.isFolder) {
    return (
      <SubMenu label={entry.name}>
        <MenuItem onClick={() => onWalk(entry)}>Walk</MenuItem>
        <MenuDivider />
        {entry.children.map((child, index) => (
          <BookmarkMenuEntry key={index} entry={child} onGoto={onGoto} onWalk={onWalk} />
        ))}
      </SubMenu>
    )
  }
  return <MenuItem onClick={() => onGoto(entry)}>{entry.name}</MenuItem>
}
